// Finance build — HTTP transport for the loan Financials tab's Income & Outflow
// read surface. A loan's recognized income events rolled up into Phoenix
// earnings / outflows / pass-through cost with expected-vs-received totals.
// The hook in @/hooks/portfolioAdmin/useIncomeLedger wraps this with React Query.

import { api } from "@/api/client";

/** A money-flow group: Phoenix earnings (PhoenixFee + Baseline), seller/broker/
 *  servicer outflows (PaidOut), or pass-through cost (Reimbursement + Processor). */
export type IncomeLedgerGroup = "earnings" | "outflow" | "passthrough";

export interface IncomeLedgerRowDto {
  classification: string;
  group: IncomeLedgerGroup;
  revenuePoolCode: string | null;
  revenuePoolName: string | null;
  paymentChannel: number;
  expectedAmount: number;
  receivedAmount: number;
  eventCount: number;
}

export interface IncomeLedgerSummaryDto {
  earningsExpected: number;
  earningsReceived: number;
  outflowsExpected: number;
  outflowsReceived: number;
  passThroughExpected: number;
  passThroughReceived: number;
}

export interface LoanIncomeLedgerDto {
  loanId: string;
  loanNumber: string;
  summary: IncomeLedgerSummaryDto;
  rows: IncomeLedgerRowDto[];
}

export const incomeLedgerApi = {
  get: (loanId: string) =>
    api.get<LoanIncomeLedgerDto>(`/portfolio-admin/loans/${loanId}/income-ledger`),
};
